import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyApngJJ84dtWnw_pZ6XsKMsWujQkiUjLwE",
  authDomain: "best-life-fitness-lp.firebaseapp.com",
  projectId: "best-life-fitness-lp",
  storageBucket: "best-life-fitness-lp.firebasestorage.app",
  messagingSenderId: "163230131968",
  appId: "1:163230131968:web:41af994f9d872d9a7a75e5",
  measurementId: "G-SRXKVM3D95"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// --- ADD THIS TEST FUNCTION ---
async function testFirestoreConnection() {
  console.log("🔥 Checking Firestore connection...");

  try {
    const testRef = collection(db, "testConnection"); // fake/test collection
    await getDocs(testRef);

    console.log("✅ Firestore is connected and readable!");
  } catch (error) {
    console.error("❌ Firestore connection failed:", error?.message);
  }
}

testFirestoreConnection();
// --------------------------------

export default app;
